module.exports = __webpack_public_path__ + "static/media/beautiful-blur-close-up-delicate-259707.287abd0b.jpg";